var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9076 11.333C13.405 11.637 13.6668 11.9819 13.6668 12.333C13.6668 12.6841 13.405 13.029 12.9076 13.333C12.4103 13.637 11.6949 13.8895 10.8335 14.0651C9.97206 14.2406 8.99487 14.333 8.00016 14.333C7.00546 14.333 6.02827 14.2406 5.16683 14.0651C4.30539 13.8895 3.59004 13.637 3.09269 13.333C2.59533 13.029 2.3335 12.6841 2.3335 12.333C2.3335 11.9819 2.59533 11.637 3.09269 11.333",
    stroke: "#E1242A",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.66699C13 9.87633 9.63256 12.0835 8.42475 12.772C8.15889 12.9235 7.84111 12.9235 7.57526 12.772C6.36745 12.0835 3 9.87633 3 6.66699C3 3.66699 5.42267 1.66699 8 1.66699C10.6667 1.66699 13 3.66699 13 6.66699Z",
    stroke: "#E1242A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1668 6.66667C10.1668 7.86328 9.19678 8.83333 8.00016 8.83333C6.80355 8.83333 5.8335 7.86328 5.8335 6.66667C5.8335 5.47005 6.80355 4.5 8.00016 4.5C9.19678 4.5 10.1668 5.47005 10.1668 6.66667Z",
    stroke: "#E1242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b03e476fdccead06b6acaacc9cd360f3.svg";
export { ForwardRef as ReactComponent };